module.exports = __webpack_public_path__ + "bc06d03e01e8e9d4fa94bb7b4cea6f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/inactive-icon-homeService@2x.png
// module id = 1762
// module chunks = 0